import { isArray, isDefined, isNumber, isString } from 'ionic-angular/util/util';
import { Field } from '../../vas/business-objects/field/field.model';
import { isInArray } from './is-in-array';
import { Model } from './model';

export const getFilterBySearchTermFn = (searchTerm: string) => {
    return (item): boolean => {

        if (!searchTerm || searchTerm.length === 0) return true;

        searchTerm = searchTerm.toLowerCase().replace(/ /, '');

        const keysNotAllowed = [
            'modified',
            'modifiedBy',
            'serverModified',
            'serverModifiedBy',
            'created',
            'createdBy',
            'serverCreated',
            'serverCreatedBy',
            'fields'
        ];

        let result;

        // basic search on object's properties
        result = Object.keys(item)
            .filter(key => key && !isNumber(item[key]) && !isInArray(key, keysNotAllowed))
            .filter(key => isString(item[key]) && item[key].toLowerCase().replace(/ /, '').indexOf(searchTerm) !== -1)
            .length > 0;

        if (result) {
            return true;
        }

        if (!isDefined(item['fields']) || !isArray(item['fields'])) {
            return false;
        }

        // advanced search on object's fields
        const fields: Array<Field> = item['fields'];

        result = !!fields.find(field => {
            let value;

            if (!isDefined(field) || !isDefined(field.value)) {
                return;
            }

            try {
                value = field.value.toString();
            } catch (e) {
                return;
            }

            return value.toLowerCase().replace(/ /, '').indexOf(searchTerm) !== -1;
        });

        return result;
    };
};

export const getFilterByPropertyFn = (property: string, filterByValue: any | Array<any>) => {

    const val = !isArray(filterByValue) ? [filterByValue] : filterByValue;

    return item =>
        val.length === 0
        || (isInArray('*', val)
        || isInArray(new Model(item).get(property), val));
};



// WEBPACK FOOTER //
// ./src/core/util/search-and-sort.ts